export function getCookie(name: string): string | null {
    const nameEquals = `${name}=`;
    const cookieArray = document.cookie.split(";");

    for (let index = 0; index < cookieArray.length; index += 1) {
        const cookie = cookieArray[index].trim();

        if (cookie.indexOf(nameEquals) === 0) {
            return cookie.substring(nameEquals.length, cookie.length);
        }
    }

    return null;
}
